export default {"src":"/_next/static/media/icon_deposit_check.877a5c4c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};